import { useState, useEffect } from "react";
import { getLiveByVidyamanMandalType } from "../../network/lib/vidyamanMandal.js";
import { getVidyamanMandalTypes } from "../../network/lib/masterData.js";
import { showHideLoader } from "../utils/helper.js";

function VidyamanMandal() {
  const [vidyamanMandalDetails, setVidyamanMandalDetails] = useState();
  const [vidyamanMandalTypes, setVidyamanMandalTypes] = useState();
  const [selectedValue, setSelectedValue] = useState("1");

  useEffect(() => {
    !vidyamanMandalTypes && populateVidyamanMandalTypes();
    !vidyamanMandalDetails && populateVidyamanMandalDetails(1);
  }, []);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    populateVidyamanMandalDetails(event.target.value);
  };

  function populateVidyamanMandalTypes() {
    getVidyamanMandalTypes().then((res) => {
      if (res.status == 200) {
        setVidyamanMandalTypes(res.data);
      }
    });
  }

  function populateVidyamanMandalDetails(vidyamanMandal) {
    showHideLoader(true);

    getLiveByVidyamanMandalType(vidyamanMandal).then((res) => {
      if (res.status == 200) {
        setVidyamanMandalDetails(res.data);
        showHideLoader();
      }
    });
  }

  const types = vidyamanMandalTypes && (
    <select onChange={handleChange} value={selectedValue}>
      <option value="0">Select</option>
      {vidyamanMandalTypes.map((x) => (
        <option key={x.id} value={x.id}>
          {x.name}
        </option>
      ))}
    </select>
  );

  const contents = vidyamanMandalDetails && (
    <div style={{ textAlign: "left",  border: '3px solid #fe6902', borderRadius: '40px', padding:"10px 25px"}}>
      <div className="Row">
        <div className="Cell">
          <div className="Table">
            <div className="Row">
              <div className="Cell">कार्यकारी मंडळ प्रकार :</div>
              <div className="Cell">{types}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="Row">
        <div className="Cell">
          <div className="profile-main">
            {vidyamanMandalDetails.map((vidyamanMandalDetail) => (
              <div className="profile-listing">
                <div className="profile-image">
                  {selectedValue == "1" && vidyamanMandalDetail.image && (
                    <img
                      id="img"
                      src={vidyamanMandalDetail.image}
                      style={{ height: "80px", width: "80px" }}
                    />
                  )}
                </div>
                <div>
                  <h2>{vidyamanMandalDetail.name}</h2>
                  {(selectedValue == "1" || selectedValue == "2") && (
                    <>
                      {vidyamanMandalDetail.designation && (
                        <div className="profile-post">
                          <span>पद: </span>
                          {vidyamanMandalDetail.designation}
                        </div>
                      )}
                      {/* {vidyamanMandalDetail.mobile && (
                        <div className="profile-post">
                          <span>मोबाइल नंबर: </span>
                          {vidyamanMandalDetail.mobile}
                        </div>
                      )} */}
                    </>
                  )}
                  {(selectedValue == "3" || selectedValue == "4") &&
                    vidyamanMandalDetail.fromPeriod && (
                      <div className="profile-post">
                        <span>कालावधी: </span>
                        {vidyamanMandalDetail.fromPeriod +
                          " - " +
                          vidyamanMandalDetail.toPeriod}
                      </div>
                    )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return contents;
}

export default VidyamanMandal;
